import { createContext, useContext, useEffect, useState } from 'react'
import api from '../services/api'
import { useDebounce } from './../hooks/useDebounce'
import { useNavigate } from 'react-router-dom'
import { objectToQueryString } from '../util/objToQueryString'
import chatbotApi from '../services/chatbotApi'

const SearchContext = createContext()

export const SearchProvider = (props) => {
  const [loadingBackground, setLoadingBackground] = useState(false)
  const [search, setSearch] = useState()
  const [filter, setFilter] = useState()
  const [products, setProducts] = useState([])
  const navigate = useNavigate()
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [orderFilter, setOrderFilter] = useState(0)
  const [usingFilter, setUsingFilter] = useState(false)
  const [isSidebarModal, setIsSidebarModal] = useState(false)
  const [isChatbotCatalog, setIsChatbotCatalog] = useState(false)

  const handleSearch = (value) => {
    if (!!value) {
      setSearch(value)
    }
  }
  const requestSearch = async () => {
    navigate('/search')
    setLoadingBackground(true)
    
    const response = await api.get(
      `/api/v2/Product/SearchBar?Order=${orderFilter}&Page=1&Size=20&OnlyB2B=true&Description=${search}&HideZeroPriced=true`,
    )
    setProducts(response.data.response.data)
    setTotalPages(response.data.response.totalPages)
    setCurrentPage(1)
    setLoadingBackground(false)
  }

  const requestSearchInfinite = async (pageToLoad = 1) => {
    if (!search) return
    if (pageToLoad === 1) navigate('chatbot-catalog/search')
  
    setLoadingBackground(true)
    try {
      const response = await (isChatbotCatalog ? chatbotApi : api).get(
        `/api/v2/Product/SearchBar?Page=${pageToLoad}&Size=5&Description=${search}&OnlyB2B=true${isChatbotCatalog ? '&IsFromChatbotService=true' : ''}`
        // colocar o onlyB2B pra buscar só do portal
      )

      const { data, totalPages: responseTotalPages } = response.data.response;
      if (data && data.length > 0) {
        setProducts(prev => 
          pageToLoad === 1 ? data : [...prev, ...data]
        )
        setCurrentPage(pageToLoad)
        setTotalPages(responseTotalPages)
      } else {
        setProducts([])
      }
    } catch (e) {
      console.error("Erro ao carregar mais resultados da busca:", e);
    } finally {
      setLoadingBackground(false);
    }
  };

  const handleFilter = (value) => {
    setFilter(value)
  }

  const requestFilter = async () => {
    if (filter) {
      const filterquery = objectToQueryString(filter)
      if (!isSidebarModal) {
        navigate('/filter')
      }
      setLoadingBackground(true)
      const response = await api.get(`api/v2/Product/FilterBar?${filterquery}&HideZeroPriced=true`)
      setProducts(response.data.response.data)
      setTotalPages(response.data.response.totalPages)
      setCurrentPage(1)
      setLoadingBackground(false)
      setUsingFilter(false)
    }
  }

  const debouncedChange = useDebounce(requestSearch)
  const debouncedFilter = useDebounce(requestFilter)
  const debouncedCatalogSearch = useDebounce(requestSearchInfinite)

  useEffect(() => {
    if (search && !usingFilter && !isChatbotCatalog) {
      debouncedChange(requestSearch)
    }

    if (search && isChatbotCatalog) {
      debouncedCatalogSearch()
    }
  }, [search])

  useEffect(() => {
    if (usingFilter) {
      debouncedFilter(requestFilter)
    }
  }, [usingFilter])

  return (
    <SearchContext.Provider
      value={{
        search,
        products,
        setProducts,
        loadingBackground,
        handleSearch,
        currentPage,
        setCurrentPage,
        totalPages,
        setTotalPages,
        orderFilter,
        setOrderFilter,
        setUsingFilter,
        filter,
        setFilter,
        handleFilter,
        setIsSidebarModal,
        usingFilter,
        setIsChatbotCatalog,
        requestSearchInfinite,
      }}
    >
      {props.children}
    </SearchContext.Provider>
  )
}

export function useSearch () {
  return useContext(SearchContext)
}

export default SearchContext
